import { sortBy } from 'lodash';

import { DataDictionary, Ordered } from '../core/types/data.types';

export const createDataDictionary = <T>(
  data: T[],
  key: string,
): DataDictionary<T> => {
  const dataDictionary = {};

  const hasData = data?.length;
  if (!hasData) {
    return dataDictionary;
  }

  const isKeyAvailable = data[0].hasOwnProperty(key);
  if (!isKeyAvailable) {
    return dataDictionary;
  }

  data.forEach((item) => {
    dataDictionary[item[key]] = item;
  });
  return dataDictionary;
};

export const sortData = <T extends Ordered>(items: T[]): T[] =>
  sortBy(items, (i) => i.DisplayOrder);
